import "./style.scss";
import { FC } from "react";
import { IUniversityPrograms } from "@/src/types/IUniversityPrograms";
import univSchoolCardBgMob from "@/src/assets/HomePage/UniversityPrograms/univ-school-card-bg-mob.png";
import { Link } from "react-router-dom";

interface IUPCard {
  card: IUniversityPrograms;
  currentTab: string;
}

const UniversityProgramsCardMob: FC<IUPCard> = ({ card, currentTab }) => {
  return (
    <Link to={card.path} className="university-programs-mob-card">
      <div className="university-programs-mob-card-bg">
        <img src={univSchoolCardBgMob} alt="Img" />
      </div>
      <div className="university-programs-mob-card-svg">
        <img src={card.img} alt="Svg" />
      </div>
      <div className="university-programs-mob-card-content">
        <div className="university-programs-mob-card-content-title">
          <p>{card.name}</p>
        </div>
        <div className="university-programs-mob-card-content-subtitle">
          <p>{currentTab}</p>
        </div>
      </div>
    </Link>
  );
};

export default UniversityProgramsCardMob;
